import React from "react";
import { useNavigate } from "react-router-dom";
import SupplyAndDischargeLogForm from "./SupplyAndDischargeLogForm";

const AddSupplyAndDischargeLog = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/supply-and-discharge-log");
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <h2>Add Supply and Discharge Log</h2>
      </div>

      <SupplyAndDischargeLogForm
        mode="add"
        isStandalone={true}
        onSaveSuccess={handleSuccess}
      />
    </>
  );
};

export default AddSupplyAndDischargeLog;
